module.exports = __webpack_public_path__ + "img/reject.485b7a41.svg";